export default __webpack_public_path__ + "static/media/581.64d9ef3e.jpg";